import { render, staticRenderFns } from "./score-old.vue?vue&type=template&id=5858b1ca&scoped=true"
import script from "./score-old.vue?vue&type=script&lang=js"
export * from "./score-old.vue?vue&type=script&lang=js"
import style0 from "./score-old.vue?vue&type=style&index=0&id=5858b1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858b1ca",
  null
  
)

export default component.exports